import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import { MDBRow, MDBCol, MDBContainer } from 'mdbreact';
import {
  Button,
  DateTimePicker,
  FileSelector,
  Option,
  Picklist,
  Textarea,
} from 'react-rainbow-components';
import 'react-quill/dist/quill.snow.css';
import { QuillModules } from '../shared/QuillOptions';
import { Commune } from '../../interfaces/Commune_interface';
import { RequestInit } from '../shared/RequestInit';
import { DateTimeFormatter } from '../shared/DateTimeFormatter';
import Preview from '../shared/Preview';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import ShowNotification from '../shared/Notification';
import { PicklistInterface } from '../../interfaces/Picklist_interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import 'react-image-crop/src/ReactCrop.scss';
import ReactCrop, { Crop, PixelCrop } from 'react-image-crop';

import useDebounceEffect from '../shared/crop/hooks/use-debounce-effect/useDebounceEffect';
import { canvasPreview } from '../shared/crop/helpers/canvas-preview/canvas-preview';
import onImageLoad from '../shared/crop/helpers/default-crop/default-crop';

const EditActualite: React.FC = (props: any) => {
  const [Titre, setTitre] = useState<string>(props.location.state.row.Titre);
  const [Text_Preview, setText_Preview] = useState<string>(
    props.location.state.row.Text_Preview
  );
  const [Text_Complet, setText_complet] = useState<string>(
    props.location.state.row.Text_Complet
  );
  const [Commune, setCommune] = useState<Commune[]>([]);
  const [Commune_Preview, setCommune_Preview] = useState<string>(
    props.location.state.row.Commune
  );
  const [Commune_ID, setCommune_ID] = useState<number | undefined>(1);
  const [Image, setImage] = useState<Blob | string>('');

  const [UploadedImage, setUploadeImage] = useState<string>(
    props.location.state.row.Photo
  );
  const [Date_Debut, setDate_Debut] = useState<string>(
    props.location.state.row.Date_Debut
  );
  const [Date_Fin, setDate_Fin] = useState<string>(
    props.location.state.row.Date_Fin
  );
  const [UploadError, setUploadError] = useState<boolean>(false);
  const [DropdownState, setDropdownState] = useState<PicklistInterface>({
    name: 'option1',
    label: "Braine-l'Alleud",
  });

  /* state for crop logic */
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const [aspect, setAspect] = useState<number>(21 / 9);
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const imageRef = useRef<HTMLImageElement>(null);
  const blobUrlRef = useRef('');
  const [blobUrl, setBlobUrl] = useState('');
  const [ImageCrop, setImageCrop] = useState<Blob | string>('');

  /* state for each input field where we set the error message*/
  const [errorTitre, setErrorTitre] = useState<string>('');
  const [errorText_Preview, setErrorText_Preview] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();

  /* function to verify that all required input fields are not empty */
  const verifyInput = () => {
    /* initial */
    let isGood: boolean = true;
    if (Titre === '') {
      setErrorTitre('Le titre est obligatoire');
      isGood = false;
    }
    if (Text_Preview === '') {
      setErrorText_Preview('Le preview est obligatoire');
      isGood = false;
    }
    /* if required fields are not empty, return true otherwise return false */
    if (isGood) {
      return true;
    } else {
      return false;
    }
  };

  /* functio that resets all errors message to be empty */
  const resetInputErrors = () => {
    setUploadError(false);
    setErrorTitre('');
    setErrorText_Preview('');
  };

  useEffect(() => {
    const fetchCommune = async () => {
      await fetch(
        'https://admin.radioemotion.be/api/commune/get',
        RequestInit as RequestInit
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.response === true) {
            setCommune(response.data);
            response.data
              .filter(
                (commune: Commune) =>
                  commune.name === props.location.state.row.Commune
              )
              .map((commune: Commune) => {
                setCommune_ID(commune.Id);
                setDropdownState({
                  name: `option${commune.Id}`,
                  label: commune.name,
                });
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchCommune();
  }, []);

  /* submit function to create the info  */
  const CreateActualite = () => {
    /* call the function to reset errors messages */
    resetInputErrors();
    if (verifyInput() === true) {
      const sendDate = async () => {
        setLoading(true);
        console.log(blobUrl);
        const formData = new FormData();
        formData.append('file', ImageCrop);
        formData.append(
          'data',
          JSON.stringify({
            Id: props.location.state.row.Id,
            Titre: Titre,
            Date_Debut: Date_Debut,
            Date_Fin: Date_Fin,
            Text_Preview: Text_Preview,
            Text_Complet: Text_Complet,
            FK_Commune: Commune_ID,
          })
        );
        const requestOptions = {
          method: 'PATCH',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        };
        await fetch(
          'https://admin.radioemotion.be/api/actualite/update',
          requestOptions as RequestInit
        )
          .then((response) => response.json())
          .then((response) => {
            setLoading(false);
            if (response.response === true) {
              history.push({
                pathname: '/actualite/list',
                state: {
                  passed: true,
                  message: `L'actualité a été mise à jour `,
                },
              });
            } else {
              setUploadError(true);
            }
          })
          .catch((err) => {
            setLoading(false);
            setUploadError(true);
          });
      };
      sendDate();
    }
  };

  async function onDownloadCropClick() {
    const image = imageRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );
    const ctx = offscreen.getContext('2d');
    if (!ctx) {
      throw new Error('No 2d context');
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height
    );

    const blob = await offscreen.convertToBlob({
      type: 'image/png',
    });
    setImageCrop(blob);

    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
    }
    blobUrlRef.current = URL.createObjectURL(blob);
    setBlobUrl(blobUrlRef.current);
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imageRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(
          imageRef.current,
          previewCanvasRef.current,
          completedCrop,
          1,
          0
        );
        onDownloadCropClick();
      }
    },
    100,
    [completedCrop]
  );

  return (
    <>
      {UploadError ? (
        <>
          <ShowNotification
            icon="times"
            iconClassName="color-red"
            bodyClassName="color-red background-color-red text-white"
            autohide={5000}
            title=""
            message="Une erreur s'est produite"
            text="maintenant"
          />
        </>
      ) : null}
      <MDBContainer className="min-h-100vh ">
        <MDBRow className="mb-5 mt-2">
          <Link to="/actualite/list">
            <Button variant="neutral" className="mt-2">
              <FontAwesomeIcon icon={faHome} className="py-1" size="2x" />
            </Button>
          </Link>
        </MDBRow>
        <MDBRow>
          <form encType="multipart/form-data" className="w-100">
            <MDBRow>
              <MDBCol className="w-100 mb-5 mx-auto">
                <Textarea
                  id="example-textarea-1"
                  label="Titre de l'info "
                  rows={2}
                  placeholder="Titre de l'info"
                  grow={true}
                  onChange={(e) => {
                    setTitre(e.target.value);
                    {
                      e.target.value === ''
                        ? setErrorTitre('Le titre est obligatoire')
                        : setErrorTitre('');
                    }
                  }}
                  value={Titre}
                  error={errorTitre}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol className="w-100 mb-5 mx-auto">
                <Textarea
                  id="Text_Preview"
                  label="Preview de l'info "
                  rows={2}
                  placeholder="Le texte montré dans le preview de l'info "
                  grow={true}
                  onChange={(e) => {
                    setText_Preview(e.target.value);
                    {
                      e.target.value === ''
                        ? setErrorText_Preview('Le preview est obligatoire')
                        : setErrorText_Preview('');
                    }
                  }}
                  value={Text_Preview}
                  error={errorText_Preview}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol className="w-100 mb-5 mx-auto">
                <label htmlFor="TextEditor" className="text-center w-100">
                  Texte complet de l'info{' '}
                </label>
                <ReactQuill
                  theme="snow"
                  value={Text_Complet}
                  onChange={setText_complet}
                  modules={QuillModules}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md={'3'} xs={'12'} sm={'12'}>
                <FileSelector
                  label="Selecteur de fichier"
                  placeholder="Glisser & déposer ou cliquer pour parcourir"
                  bottomHelpText="Selectionez seulement un fichier"
                  onChange={(value) => {
                    setImage(value[0]);
                    setUploadeImage(URL.createObjectURL(value[0]));
                  }}
                />
              </MDBCol>
              <MDBCol md={'3'} xs={'12'} sm={'12'}>
                <Picklist
                  onChange={(value) => {
                    setCommune_Preview(Commune[parseInt(value.value) - 1].name);
                    setCommune_ID(value.value);
                    setDropdownState({ name: value.name, label: value.label });
                  }}
                  placeholder="Choisissez la ville"
                  label="Choisissez la ville"
                  name="Ville"
                  variant="default"
                  value={DropdownState}
                >
                  {Commune.map((data: Commune) => (
                    <Option
                      key={data.Id}
                      name={`option${data.Id}`}
                      label={data.name}
                      value={data.Id}
                    />
                  ))}
                </Picklist>
              </MDBCol>
              <MDBCol xs={'12'} sm={'12'} md={'3'}>
                <DateTimePicker
                  value={Date_Debut}
                  label="Date de debut"
                  locale="fr"
                  formatStyle={'large'}
                  onChange={(value) =>
                    setDate_Debut(DateTimeFormatter(value, true))
                  }
                  hour24={true}
                />
              </MDBCol>
              <MDBCol md={'3'} xs={'12'} sm={'12'}>
                <DateTimePicker
                  value={Date_Fin}
                  formatStyle={'large'}
                  locale="fr"
                  label="Date de fin"
                  onChange={(value) =>
                    setDate_Fin(DateTimeFormatter(value, false))
                  }
                  hour24={true}
                />
              </MDBCol>
            </MDBRow>
          </form>
        </MDBRow>
        {UploadedImage !== props.location.state.row.Photo && (
          <>
            <MDBCol className="text-center mb-4 mt-5">
              <hr />
              <h1 className="font-size-1vw">
                Veuillez sélectionner le cadrage pour l'image
              </h1>
            </MDBCol>
            <MDBRow>
              <MDBCol>
                <ReactCrop
                  className="w-100"
                  crop={crop}
                  aspect={21 / 9}
                  onChange={(_, percentCrop) => setCrop(percentCrop)}
                  onComplete={(c) => {
                    setCompletedCrop(c);
                  }}
                >
                  <img
                    src={UploadedImage}
                    style={{ width: '100%' }}
                    ref={imageRef}
                    crossOrigin="anonymous"
                    onLoad={(e) => onImageLoad(e, { aspect, setCrop })}
                  />
                </ReactCrop>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol>
                <div>
                  <canvas
                    ref={previewCanvasRef}
                    style={{
                      display: 'none',
                    }}
                  />
                </div>
              </MDBCol>
            </MDBRow>
          </>
        )}
        {Commune.length > 0 ? (
          <MDBRow>
            <MDBCol className="preview">
              <Preview
                Titre={Titre}
                TextComplet={Text_Complet}
                Image={blobUrl !== '' ? blobUrl : UploadedImage}
                DateDebut={Date_Debut}
                DateFin={Date_Fin}
                TextPreview={Text_Preview}
                Commune={{ name: Commune_Preview }}
              ></Preview>
            </MDBCol>
          </MDBRow>
        ) : (
          <MDBRow>
            <MDBCol></MDBCol>
          </MDBRow>
        )}
        <MDBRow end>
          <Button
            isLoading={loading}
            label="Mettre à jour"
            onClick={() => CreateActualite()}
            variant="brand"
            className="mt-2 mb-4 font-weight-bold"
          />
        </MDBRow>
      </MDBContainer>
    </>
  );
};
export default EditActualite;
